export default __webpack_public_path__ + "static/media/admin_product_dashboard.2cc710ac.svg";